import { syllabize as syllabizeCore } from "./core/syllabize.js";
import { splitCyrillicNG, unifyCyrillicNG } from "./exceptions/ngWords.js";
import { extractIotaConsonants, hideSoftSign, recoverIotas, recoverSoftSign } from "./helpers/cyrillicHelpers.js";
import { splitBigrams, unifyBigrams } from "./helpers/latinBigramHelpers.js";
import { validateCyrillicWord, validateLatinWord } from "./helpers/validators.js";
import { applyCaseMap, generateCaseMap } from "./utils/casing.js";
export function syllabize(word) {
  if (word.length === 0) {
    return [];
  }

  const unifiedWord = unifyBigrams(word);
  validateLatinWord(unifiedWord);
  const caseMap = generateCaseMap(word);
  const syllables = syllabizeCore(unifiedWord, 'latin').map(splitBigrams);
  return applyCaseMap(syllables, caseMap);
}
export function syllabizeCyrillic(word) {
  if (word.length === 0) {
    return [];
  }

  validateCyrillicWord(word);
  const caseMap = generateCaseMap(word);
  const unifiedWord = extractIotaConsonants(hideSoftSign(unifyCyrillicNG(word)));
  const syllables = syllabizeCore(unifiedWord, 'cyrillic').map(syllable => recoverIotas(recoverSoftSign(splitCyrillicNG(syllable))));
  return applyCaseMap(syllables, caseMap);
}